<template>
  <div class="editTopics">
    <div class="editTopics-title">
      <h4>Topics</h4>
    </div>
    <div class="editTopics-controls">
      <pill v-for="topic in topics"
        clearable
        :key="topic.subject"
        @action:delete="() => onDelete(topic)"
      >
        {{ topic.subject }}
      </pill>
      <tag-select @action:openDropdown="onOpenDropdown"
        :options="topicOptions"
        :optionsLoading="optionsLoading"
        placeholder="Select Topic"
        @input:search="onSearchInput"
        @input:select="onSelectInput"
      />
    </div>
  </div>
</template>

<script>
import Pill from './Pill.vue'
import { computed } from '@vue/composition-api'
import TagSelect from './TagSelect.vue'
import { useTopics } from '@/features'

export default {
  name: 'EditTopics',

  components: {
    Pill,
    TagSelect
  },

  props: {
    topics: {
      type: Array,
      default: () => []
    }
  },

  emits: [
    'action:addTopic',
    'action:removeTopic'
  ],

  setup (props, { emit }) {
    const topics = useTopics()

    const onOpenDropdown = async () => {
      if (!topics.topicOptions.value.length) {
        await topics.loadTopicOptions(null, 20)
      }
    }
    const onSearchInput = async value => {
      await topics.loadTopicOptions(value, 20)
    }
    const onSelectInput = v => {
       const newTopic = topics.topicOptions.value.find(t => t.subject ===  v)
       emit('action:addTopic', newTopic)
    }
    const onDelete = v => emit('action:removeTopic', v)

    return {
      onOpenDropdown,
      optionsLoading: topics.topicOptionsLoading,
      topicOptions: computed(() => topics.topicOptions.value.map(opt => ({ value: opt.subject, label: opt.subject }))),
      onSearchInput,
      onSelectInput,
      onDelete
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.editTopics {
  margin-bottom: 20px;

  &-title {
    padding-bottom: 5px;
    border-bottom: 1px solid $very-light-pink;
    margin-bottom: 10px;

    h4 {
      margin: 0;
      font-family: $defaultFont;
      font-size: 12px;
      font-weight: 400;
      color: $slate-grey;
    }
  }

  &-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    align-items: center;
  }
}
</style>
